<template>
  <div
    v-if="
      has_perm('create_apartment_schedule_progress') ||
        GET_ACCOUNT_DATA.id == 1 ||
        has_perm('update_apartment_schedule_progress')
    "
  >
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(pagetitle) }}</h3>
      </div>
      <form class="form-horizontal">
        <div class="box-body">
          <div class="form-group col-lg-12 required">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.contract_number")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <!-- <input
                v-model="apartment.contract_number"
                type="text"
                class="form-control"
                :placeholder="$t('apartment_schedule_progress.contract_number')"
              /> -->
              <b-form-select
                :options="contract_list"
                required
                v-model="apartment.contract_number"
                class="form-control"
              />
              <span v-if="contractNumberStatus == false" class="help is-danger">
                <font color="red">{{ $t(error_msg.contractNumberSmg) }}</font>
              </span>
            </div>
          </div>
          <div class="form-group col-lg-12 required">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.contract_name")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <input
                v-model="apartment.contract_name"
                type="text"
                class="form-control"
                :placeholder="$t('apartment_schedule_progress.contract_name')"
              />
              <span v-if="contractNameStatus == false" class="help is-danger">
                <font color="red">{{ $t(error_msg.contractNameSmg) }}</font>
              </span>
            </div>
          </div>
          <div class="form-group col-lg-12  required">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.date_from")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <date-picker
                v-model="apartment.date_from"
                :config="options"
              ></date-picker>
            </div>
          </div>
          <div class="form-group col-lg-12 required">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.date_to")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <date-picker
                v-model="apartment.date_to"
                :config="options"
              ></date-picker>
              <span v-if="datefromtoStatus == false" class="help is-danger">
                <font color="red">{{ $t(error_msg.datefromtoSmg) }}</font>
              </span>
            </div>
          </div>
          <div class="form-group col-lg-12 required">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.customer")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <b-form-input
                type="text"
                v-model="apartment.customer"
                :placeholder="$t('apartment_schedule_progress.customer')"
              />
              <span v-if="customerStatus == false" class="help is-danger">
                <font color="red">{{ $t(error_msg.customerSmg) }}</font>
              </span>
            </div>
          </div>
          <div class="form-group col-lg-12  required">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.phone")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <b-form-input
                type="text"
                v-model="apartment.phone"
                :placeholder="$t('apartment_schedule_progress.phone')"
              />
              <span v-if="phoneStatus == false" class="help is-danger">
                <font color="red">{{ $t(error_msg.phoneNameSmg) }}</font>
              </span>
            </div>
          </div>
          <div class="form-group col-lg-12  required">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.email")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <b-form-input
                type="text"
                v-model="apartment.email"
                :placeholder="$t('you@example.com')"
              />
              <span v-if="emailStatus == false" class="help is-danger">
                <font color="red">{{ $t(error_msg.emailNameSmg) }}</font>
              </span>
            </div>
          </div>
          <div class="form-group col-lg-12">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.main_contact")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <b-form-input
                type="text"
                v-model="apartment.main_contact"
                :placeholder="$t('apartment_schedule_progress.main_contact')"
              />
            </div>
          </div>
          <div class="form-group col-lg-12">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.support_contact")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <b-form-input
                type="text"
                v-model="apartment.support_contact"
                :placeholder="$t('apartment_schedule_progress.support_contact')"
              />
            </div>
          </div>
          <div class="form-group col-lg-12">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.user_created")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <b-form-input
                disabled
                type="text"
                v-model="apartment.user_created"
                :placeholder="$t('apartment_schedule_progress.user_created')"
              />
            </div>
          </div>
          <div class="form-group col-lg-12">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.date_created")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <date-picker
                disabled="True"
                v-model="apartment.date_created"
                :config="options"
              ></date-picker>
            </div>
          </div>
          <div class="form-group col-lg-12">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_schedule_progress.progress")
            }}</label>
            <div class="col-sm-6 col-md-6 col-lg-6" style="display: flex;">
              <b-form-input
                style="width: 85%"
                type="range"
                v-model="apartment.progress"
              />
              <span style="width: 15%; display; text-align: right;"
                >{{ apartment.progress }} %</span
              >
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger pull-left"
            @click="onApartmentCancel"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            v-if="
              (has_perm('create_apartment_schedule_progress') ||
                GET_ACCOUNT_DATA.id == 1) &&
                apartment.id == 0
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onApartmentSubmit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-floppy-saved"></i>
            </span>
            {{ $t("common.add") }}
          </button>
          <button
            v-if="
              (has_perm('update_apartment_schedule_progress') ||
                GET_ACCOUNT_DATA.id == 1) &&
                apartment.id != 0
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onApartmentSubmit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-floppy-saved"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </form>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <router-view></router-view>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import utils from "@/lib/utils";
import datePicker from "vue-bootstrap-datetimepicker";

export default {
  name: "ApartmentScheduleProgressAdd",
  data() {
    return {
      options: {
        format: "DD-MM-YYYY",
        useCurrent: false
      },
      pagetitle: "apartment_schedule_progress.editaddnew[0]",
      apartment: {
        id: 0,
        contract_number: null,
        contract_name: "",
        date_from: utils.getToDay(),
        date_to: utils.getToDay(),
        progress: 0,
        customer: "",
        phone: "",
        email: "",
        main_contact: "",
        support_contact: "",
        user_created: 0,
        date_created: utils.getToDay()
      },
      contract_list: [],
      isLoading: false,
      error_msg: {
        emailNameSmg: "",
        phoneNameSmg: "",
        contractNumberSmg: "",
        contractNameSmg: "",
        datefromtoSmg: "",
        customerSmg: ""
      },
      emailStatus: true,
      phoneStatus: true,
      contractNumberStatus: true,
      datefromtoStatus: true,
      contractNameStatus: true,
      customerStatus: true
    };
  },

  watch: {
    APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA: function() {
      this.apartment.contract_number = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.contract_number;
      this.apartment.contract_name = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.contract_name;
      this.apartment.date_from = utils.formatSqlDate(this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.date_from, null, "DD-MM-YYYY");
      this.apartment.date_to = utils.formatSqlDate(this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.date_to, null, "DD-MM-YYYY");
      this.apartment.progress = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.progress;
      this.apartment.customer = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.customer;
      this.apartment.phone = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.phone;
      this.apartment.email = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.email;
      this.apartment.main_contact = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.main_contact;
      this.apartment.support_contact = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.support_contact;
      this.apartment.user_created = this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.user_created;
      this.apartment.date_created = utils.formatSqlDate(this.APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA.date_created, null, "DD-MM-YYYY");
      this.GET_USER_DETAIL({ id: this.apartment.user_created }).then(
        function(res) {
          this.apartment.user_created = res.last_name + " " + res.first_name;
        }.bind(this)
      );
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA",
      "GET_ACCOUNT_DATA"
      // "GET_CONTRACT_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ADD_APARTMENT_SCHEDULE_PROGRESS",
      "UPDATE_APARTMENT_SCHEDULE_PROGRESS",
      "GET_APARTMENT_SCHEDULE_PROGRESS_DETAIL",
      "ON_SHOW_TOAST",
      "GET_USER_DETAIL",
      "GET_CONTRACT_LIST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onApartmentCancel: function() {
      this.$router.push({
        name: "ApartmentScheduleProgressList"
      });
    },
    validateContractName: function() {
      this.error_msg.contractNameSmg = "";
      this.contractNameStatus = true;
      if (
        this.apartment.contract_name == null ||
        this.apartment.contract_name == ""
      ) {
        this.error_msg.contractNameSmg = "common.error_msg[0].required";
        this.contractNameStatus = false;
      }
      return this.contractNameStatus;
    },
    validatePhone: function() {
      this.error_msg.phoneNameSmg = "";
      this.phoneStatus = true;
      if (this.apartment.phone == null || this.apartment.phone == "") {
        this.error_msg.phoneNameSmg = "common.error_msg[0].required";
        this.phoneStatus = false;
      } else if (utils.validatePhone(this.apartment.phone) == false) {
        this.error_msg.phoneNameSmg = "common.error_msg[3].phone_invalidate";
        this.phoneStatus = false;
      }
      return this.phoneStatus;
    },
    validateContractNumber: function() {
      this.error_msg.contractNumberSmg = "";
      this.contractNumberStatus = true;
      if (
        this.apartment.contract_number == null ||
        this.apartment.contract_number == ""
      ) {
        this.error_msg.contractNumberSmg = "common.error_msg[0].required";
        this.contractNumberStatus = false;
      }
      return this.contractNumberStatus;
    },
    validateEmail: function() {
      this.error_msg.emailNameSmg = "";
      this.emailStatus = true;
      if (this.apartment.email == null || this.apartment.email == "") {
        this.error_msg.emailNameSmg = "common.error_msg[0].required";
        this.emailStatus = false;
      } else if (utils.validateEmailAddress(this.apartment.email) == false) {
        this.error_msg.emailNameSmg = "common.error_msg[2].email_invalidate";
        this.emailStatus = false;
      }
      return this.emailStatus;
    },
    validateDateFromTo: function() {
      this.error_msg.datefromtoSmg = "";
      this.datefromtoStatus = true;
      if (this.apartment.date_from > this.apartment.date_to) {
        this.error_msg.datefromtoSmg = "common.error_msg[5].date_from_to";
        this.datefromtoStatus = false;
      }
      return this.datefromtoStatus;
    },
    validateCustomer: function() {
      this.error_msg.customerSmg = "";
      this.customerStatus = true;
      if (this.apartment.customer == null || this.apartment.customer == "") {
        this.error_msg.customerSmg = "common.error_msg[0].required";
        this.customerStatus = false;
      }
      return this.customerStatus;
    },
    checkform: function() {
      let checkContractNumber = this.validateContractNumber();
      let chechkContractName = this.validateContractName();
      let checkDateFromTo = this.validateDateFromTo();
      let checkCustomer = this.validateCustomer();
      let checkPhone = this.validatePhone();
      let checkEmail = this.validateEmail();
      if (
        checkPhone &&
        checkEmail &&
        checkContractNumber &&
        chechkContractName &&
        checkDateFromTo &&
        checkCustomer
      ) {
        return true;
      } else {
        return false;
      }
    },
    onApartmentSubmit: function(event) {
      if (this.checkform()) {
        let data = {
          contract_number: this.apartment.contract_number,
          contract_name: this.apartment.contract_name,
          date_from: utils.formatSqlDate(this.apartment.date_from, "DD-MM-YYYY", "YYYY-MM-DD"),
          date_to: utils.formatSqlDate(this.apartment.date_to, "DD-MM-YYYY", "YYYY-MM-DD"),
          progress: parseInt(this.apartment.progress),
          customer: this.apartment.customer,
          phone: this.apartment.phone,
          email: this.apartment.email,
          main_contact: this.apartment.main_contact,
          support_contact: this.apartment.support_contact,
          date_created: utils.formatSqlDate(this.apartment.date_created, "DD-MM-YYYY", "YYYY-MM-DD")
        };
        if (parseInt(this.apartment.id) == 0) {
          this.ADD_APARTMENT_SCHEDULE_PROGRESS({ data: data })
            .then(
              function() {
                this.$router.push({ name: "ApartmentScheduleProgressList" });
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_APARTMENT_SCHEDULE_PROGRESS({
            id: this.apartment.id,
            data: data
          })
            .then(
              function() {
                this.$router.push({ name: "ApartmentScheduleProgressList" });
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        }
      }
    }
  },
  mounted() {
    // Get full name login user
    this.GET_USER_DETAIL({ id: this.GET_ACCOUNT_DATA.id }).then(
      function(res) {
        this.apartment.user_created = res.last_name + " " + res.first_name;
      }.bind(this)
    );

    let id = this.$route.params.id;
    if (parseInt(id) != 0) {
      this.apartment.id = parseInt(this.$route.params.id);
      this.pagetitle = "apartment_schedule_progress.editaddnew[1]";
      this.isLoading = true;
      this.GET_APARTMENT_SCHEDULE_PROGRESS_DETAIL({ id: this.apartment.id })
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(function(error) {
          this.isLoading = false;
        });
    }
    this.GET_CONTRACT_LIST().then(
      function(res) {
        let contracts = [
          {
            value: null,
            text: "Select One"
          }
        ];
        let data = res.data.results;
        data.forEach(c => {
          let contract = {
            value: c.id,
            text: c.contract_no
          };
          contracts.push(contract);
        });
        this.contract_list = contracts;
      }.bind(this)
    );
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "date-picker": datePicker
  }
};
</script>
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentScheduleProgressAdd.vue